import { render, staticRenderFns } from "./_base-aside.vue?vue&type=template&id=117cd240&scoped=true&"
import script from "./_base-aside.vue?vue&type=script&lang=js&"
export * from "./_base-aside.vue?vue&type=script&lang=js&"
import style0 from "./_base-aside.vue?vue&type=style&index=0&id=117cd240&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117cd240",
  null
  
)

export default component.exports